module.exports = __webpack_public_path__ + "static/img/concise-logo.2046663d.svg";